export const contentBundleSchemaVersion = 1;
export const signatureAlgorithms = ["ECDSA_P256_SHA256"];
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isNonEmptyString(value) {
    return typeof value === "string" && value.trim().length > 0;
}
export function validateContentBundleStructure(value) {
    if (!isRecord(value)) {
        return { valid: false, issues: ["INVALID_ENVELOPE"] };
    }
    const issues = [];
    const { body, integrity, signature } = value;
    if (!isRecord(body)) {
        return { valid: false, issues: ["INVALID_BODY"] };
    }
    if (!isNonEmptyString(body.bundleId))
        issues.push("INVALID_BUNDLE_ID");
    if (!Number.isInteger(body.schemaVersion) || Number(body.schemaVersion) < 1) {
        issues.push("INVALID_SCHEMA_VERSION");
    }
    if (body.locale !== "th" && body.locale !== "en")
        issues.push("INVALID_LOCALE");
    if (!isNonEmptyString(body.contentVersion))
        issues.push("INVALID_CONTENT_VERSION");
    if (!isNonEmptyString(body.publishedAt) || Number.isNaN(Date.parse(body.publishedAt))) {
        issues.push("INVALID_PUBLISHED_AT");
    }
    if (!isNonEmptyString(body.provenanceManifestId)) {
        issues.push("INVALID_PROVENANCE_REFERENCE");
    }
    if (!isRecord(body.compatibility) ||
        !isNonEmptyString(body.compatibility.minimumAppVersion) ||
        !Number.isInteger(body.compatibility.maximumSchemaVersion) ||
        !Array.isArray(body.compatibility.requiredFeatures) ||
        !body.compatibility.requiredFeatures.every(isNonEmptyString)) {
        issues.push("INVALID_COMPATIBILITY");
    }
    if (!isRecord(integrity) ||
        integrity.algorithm !== "SHA-256" ||
        !isNonEmptyString(integrity.hash)) {
        issues.push("INVALID_INTEGRITY_METADATA");
    }
    if (!isRecord(signature) ||
        signature.algorithm !== "ECDSA_P256_SHA256" ||
        !isNonEmptyString(signature.keyId) ||
        !isNonEmptyString(signature.value)) {
        issues.push("INVALID_SIGNATURE_METADATA");
    }
    return { valid: issues.length === 0, issues };
}
